import { useLayoutEffect, useState } from 'react'

/**
 * Whether `box` has more content than its height shows, so it scrolls. Measured again whenever the
 * box or any of its children changes size, and whenever children come or go.
 */
export function useScrolls(box: HTMLElement | null): boolean {
  const [scrolls, setScrolls] = useState(false)

  useLayoutEffect(() => {
    if (box === null) {
      return undefined
    }
    const measure = () => setScrolls(box.scrollHeight > box.clientHeight + 1)
    const resizes = typeof ResizeObserver === 'undefined' ? undefined : new ResizeObserver(measure)
    const watch = () => {
      resizes?.disconnect()
      resizes?.observe(box)
      for (const child of Array.from(box.children)) {
        resizes?.observe(child)
      }
      measure()
    }
    const changes = new MutationObserver(watch)
    changes.observe(box, { childList: true, subtree: true, characterData: true })
    watch()
    return () => {
      changes.disconnect()
      resizes?.disconnect()
    }
  }, [box])

  return scrolls
}
